<script setup lang="ts">
// The full layout (wp/shell §4.14): the page alone — no navbar, nav or footer (auth, error, maintenance, public pages).
// `data-app-content` marks the content the e2e captures read (tests/e2e/helpers/content.ts).
</script>

<template>
  <div class="layout-full min-h-screen" data-app-content data-layout="full">
    <slot />
  </div>
</template>
